export const DIY_FAQ = 'diy-faq';
